export default "__VITE_ASSET__UGHuVHFI__"